import React, {Component} from 'react'
import { connect } from 'react-redux'

import Popup from '../Popup/index';

import Registry from '../../../registry/index';

import {
    CONNECTION_STATE_INITIAL,
    CONNECTION_STATE_CONNECTING,
    CONNECTION_STATE_CONNECTED,
    CONNECTION_STATE_RECONNECTING,
    CONNECTION_STATE_DISCONNECTED_BY_SERVER,
} from '../../../constants/connectionState';

class ConnectionStatePopup extends Popup {
    constructor(props) {
        super(props);

        this.showOverlay = true;
        this.userClosable = false;
        this.afterClosePositionReset = false;

        this.reconnect = this.reconnect.bind(this);
        this.disconnect_other = this.disconnect_other.bind(this);
        this.enter = this.enter.bind(this);
        this.quit = this.quit.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let {connectionState} = nextProps;

        if (this.props.connectionState == connectionState) return;

        let visibleStates = [
            CONNECTION_STATE_CONNECTING,
            CONNECTION_STATE_RECONNECTING,
            CONNECTION_STATE_DISCONNECTED_BY_SERVER
        ];

        if (visibleStates.indexOf(connectionState) != -1) {
            this.open();
        }

        if (nextProps.connectionState == CONNECTION_STATE_CONNECTED &&
            nextProps.otherConnections > 0) {
            this.open();
        } else if (connectionState == CONNECTION_STATE_CONNECTED) {
            this.close();
        }
    }

    enter() {
        let chatInterface = Registry.get('chatInterface');
        chatInterface.finishConnection();
        this.close();
    }

    quit() {
        if (window.opener && window.opener !== window) {
          // you are in a popup
          window.close();
        } else {
            window.location = "/";
        }
    }

    reconnect() {
        let chatInterface = Registry.get('chatInterface');
        chatInterface.forceReconnection();
    }

    disconnect_other() {
        let chatInterface = Registry.get('chatInterface');
        chatInterface.disconnectOther();
        this.close();
    }

    open() {
        if ((this.state.visibility === 'shown' || this.state.visibility == 'opening')) return;
        Popup.prototype.open.call(this)
    }

    render() {
        let lang = Registry.get('locale');

        let {connectionState} = this.props;

        let displayClass = "";

        switch (connectionState) {
            case CONNECTION_STATE_CONNECTED:
                displayClass = "connected";
                break;
            case CONNECTION_STATE_CONNECTING:
                displayClass = "connecting";
                break;
            case CONNECTION_STATE_RECONNECTING:
                displayClass = "reconnecting";
                break;
            case CONNECTION_STATE_DISCONNECTED_BY_SERVER:
                displayClass = "disconnected";
                break;
        }

        let cssClasses = ['popup', 'popup-connecting-modal', 'popup-connection-state'];
        cssClasses.push(displayClass);
        cssClasses.push(this.state.visibility);

        const cameraAccess = document.querySelector('.camera-access');
        cameraAccess ? cameraAccess.style.display = 'none' : false;

        return (
            <div className={cssClasses.join(' ')} ref={(ref) => this._ref = ref}>
                <div className="state-connected-with-others">
                    <p>{lang.already_connected}</p>
                    <button className="popup-button reconnect" onClick={this.enter}>{lang.yes}</button>&nbsp;&nbsp;
                    <button className="popup-button reconnect" onClick={this.quit}>{lang.cancel}</button>
                </div>
                <div className="state-connecting">{lang.entering_chat_room}</div>
                <div className="state-reconnecting" dangerouslySetInnerHTML={{__html:lang.reconnection_message}}></div>
                <div className="state-disconnected">
                    <p>{lang.disconnected_message}</p>
                    <button className="popup-button reconnect" onClick={this.reconnect}>{lang.reconnect}</button>
                </div>

            </div>
        )
    }

}
function mapStateToProps(state, ownProps) {
    return {
        connectionState: state.connectionState,
        otherConnections: state.currentUser.other_connections
    }
}

var ConnectionStatePopup_connect = connect(mapStateToProps, null, null, {forwardRef: true})(ConnectionStatePopup);

ConnectionStatePopup_connect.generateKey = function() { return 'connection-state-popup' };
ConnectionStatePopup_connect.mount = function(props) { return Popup.mount(ConnectionStatePopup_connect, props) };

export default ConnectionStatePopup_connect;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ConnectionStatePopup/index.js